
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expired",
      function () {
        return require("private-next-pages/expired.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expired"])
      });
    }
  